import React from 'react'
import { Radio, Tooltip } from 'antd'
import styles from './index.module.scss'

export default function TooltipSquareRadioButton({ icon, onClick, title, disabled, isSelected, size, 'data-test-id': dataTestId }) {
  return (
    <span className={styles.container} data-test-id={dataTestId}>
      <Tooltip placement="bottom" title={title}>
        <Radio.Group
          value={isSelected ? 'selected' : null}
          disabled={disabled}
          size={size}
        >
          <Radio.Button
            value="selected"
            aria-label={title}
            onClick={onClick}
            size={size}
          >
            {icon}
          </Radio.Button>
        </Radio.Group>
      </Tooltip>
    </span>
  )
}
